import React, { useState } from "react";
import { content } from "../data.tsx";
import Button from "../components/button/Button.tsx";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState<string | null>();
  const navigate = useNavigate();

  return (
    <footer className="w-full bg-gradient-to-br from-blue to-[#3F86C2] text-white">
      <div className="w-[90%] max-w-[1440px] mx-auto py-14 lg:py-16">
        <div className="flex lg:flex-row flex-col gap-10 lg:gap-12 lg:items-center justify-between">
          <div className="lg:w-[40%] flex flex-col gap-4">
            <Link to="/" className="inline-block">
              <img
                src="/assets/images/coachai.png"
                alt="Coach AI"
                className="w-[100px] brightness-0 invert"
              />
            </Link>
            <p className="text-white/80 text-[14.5px] leading-relaxed max-w-md">
              Discover the power of AI-driven coaching designed to help you grow professionally with precision and clarity.
            </p>
          </div>

          <div className="lg:w-[45%] flex flex-col gap-3">
            <h4 className="font-display font-medium text-base text-white">Stay in the loop</h4>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                placeholder="youremail@email.com"
                className="flex-1 bg-white/10 border border-white/20 placeholder-white/60 text-white rounded-xl h-12 px-5 outline-none backdrop-blur-sm focus:bg-white/15"
                onChange={(e) => setEmail(e.target.value.toLocaleLowerCase())}
              />
              <Button
                disabled={!email}
                children={"Get Started"}
                className="!w-auto !px-6 !bg-white !text-blue hover:!bg-white/90"
                onClick={() => navigate(`/contact?email=${email}`)}
              />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/70 text-sm">
            &#169; {currentYear} Coach AI. All rights reserved.
          </p>
          <div className="flex gap-6">
            {content?.menuItems?.map((item, idx) => (
              <Link
                to={item.url}
                key={idx}
                className="text-white/75 text-sm hover:text-white transition-colors"
              >
                {item.head}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
